/**
 * Size Guide Component
 * Functionality for a scrollable table with controls & active states
 */
class SizeGuideComponent extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-table-container]');
    this.controls = this.querySelectorAll('[data-table-control]');

    this.prevButton = this.querySelector('[data-table-control="prev"]');
    this.nextButton = this.querySelector('[data-table-control="next"]');

    this.canScrollLeft = false;
    this.canScrollRight = false;

    //? Tabs
    this.tabControls = this.querySelectorAll('[data-size-guide-tab-control]');
    this.panels = this.querySelectorAll('[data-size-guide-panel-id]');

    if (!this.container || !this.controls) return;

    this.setupEventListeners();
    this.updateScrollState();
    this.updateActiveTable();
  }

  setupEventListeners() {
    if (this.prevButton) this.prevButton.addEventListener('click', this.scrollLeft.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.scrollRight.bind(this));

    if (this.tabControls) {
      this.tabControls.forEach((tabControl) => {
        tabControl.addEventListener('click', this.updateActiveTable.bind(this));
      });
    }

    this.container.addEventListener('scroll', this.updateScrollState.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.updateScrollState();
  }

  updateActiveTable(e) {
    if (!e || !e?.target) return;
    const selectedTab = e.target.dataset.sizeGuideTabControl;

    this.panels.forEach((panel) => {
      const match = panel.dataset.sizeGuidePanelId === selectedTab;
      panel.dataset.active = match;
    });

    this.tabControls.forEach((tabControl) => {
      tabControl.dataset.active = tabControl.dataset.sizeGuideTabControl === selectedTab;
    });
  }

  updateScrollState() {
    const { scrollLeft, scrollWidth, clientWidth } = this.container;
    this.canScrollLeft = scrollLeft > 0;
    this.canScrollRight = scrollLeft < scrollWidth - clientWidth;

    this.prevButton.disabled = !this.canScrollLeft;
    this.nextButton.disabled = !this.canScrollRight;

    if (!this.canScrollLeft && !this.canScrollRight) {
      this.controls.forEach((control) => control.classList.add('hidden'));
    } else {
      this.controls.forEach((control) => control.classList.remove('hidden'));
    }
  }

  scrollLeft() {
    if (this.canScrollLeft) {
      this.container.scrollBy({ left: -200, behavior: 'smooth' });
    }
  }

  scrollRight() {
    if (this.canScrollRight) {
      this.container.scrollBy({ left: 200, behavior: 'smooth' });
    }
  }
}

customElements.define('size-guide-component', SizeGuideComponent);
